import React from 'react';
import { Link } from 'react-router-dom';

const MARKETING_SITE = 'https://www.prediktive.com';

const NAV_LINKS = [
	{ label: 'Home', href: MARKETING_SITE },
	{ label: 'Careers', to: '/jobs' }
];

export default function OpenJobsTopNav() {
	return (
		<header className="open-jobs-top-nav">
			<div className="open-jobs-top-nav-inner">
				<a className="open-jobs-top-nav-logo" href={MARKETING_SITE}>
					<img src="/jobs/prediktive-logo.svg" alt="Prediktive" />
				</a>
				<nav className="open-jobs-top-nav-links">
					{NAV_LINKS.map(link =>
						link.to ? (
							<Link key={link.label} className="is-active" to={link.to}>
								{link.label}
							</Link>
						) : (
							<a key={link.label} href={link.href}>
								{link.label}
							</a>
						)
					)}
				</nav>
			</div>
		</header>
	);
}
